import scrollStopper from 'hocs/scrollStopper';
import React from 'react';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import resolvePath from 'utils/resolvePath';
import zeroPaddingLoading from 'utils/zeroPaddingLoading';
export default (props) => {
    const { isFetchingConversation, isFetchingLocations, isFetchingNotification, isFetchingOrganizations, isFetchingStudentsMe, isFetchingTeachersMe, showAnyway = false, } = props;
    const items = [
        isFetchingConversation,
        isFetchingLocations,
        isFetchingNotification,
        isFetchingOrganizations,
        isFetchingStudentsMe,
        isFetchingTeachersMe,
    ];
    return (React.createElement(Container, { "data-hidden": isFetching(items) === false && showAnyway === false },
        isFetching(items) || showAnyway ? React.createElement(ScrollStopper, null) : null,
        React.createElement(Img, null)));
};
const imageCount = 103;
const imageSize = 400;
const isFetching = (target) => {
    return target.includes(true);
};
const ScrollStopper = styled(scrollStopper(() => React.createElement("div", null))) ``;
const initialPosition = [...Array(imageCount)]
    .map((element, index) => {
    return `center ${imageSize * index}px`;
})
    .join(',');
const endPosition = [...Array(imageCount)]
    .map((element, index) => {
    return `center ${-imageCount * imageSize + imageSize * index}px`;
})
    .join(',');
const loadingImages = [...Array(imageCount)]
    .map((element, index) => {
    return `url(${resolvePath.image(`common/loading/loading${zeroPaddingLoading(index)}.jpg`)})`;
})
    .join(',');
const loading = keyframes `
  0% {
    background-position: ${initialPosition};
  }
  100% {
    background-position: ${endPosition};
  }
`;
const Container = styled.div `
  visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  background-color: #ffffff;
  opacity: 0;
  transition:
    visibility 100ms linear 0ms,
    opacity 100ms linear 0ms;

  &[data-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition:
      visibility 100ms linear 0ms,
      opacity 100ms linear 0ms;
  }
  &[data-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition:
      visibility 0s linear 0s,
      opacity 0s linear 0s;
  }
  z-index: 9999;
`;
const Img = styled.div `
  width: 300px;
  height: 300px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: ${initialPosition};
  background-image: ${loadingImages};
  animation: ${loading} 3s steps(${imageCount}) 0s infinite;
`;
